import api from './authService';

export const adminSiteSettingsService = {
  // Get site settings
  get: async () => {
    const response = await api.get('/admin/site-settings');
    return response.data;
  },

  // Create or update site settings
  save: async (data) => {
    const response = await api.post('/admin/site-settings', data);
    return response.data;
  },

  // Upload logo to S3, returns { url }
  uploadLogo: async (file, onProgress) => {
    const formData = new FormData();
    formData.append('logo', file);
    const response = await api.post('/admin/site-settings/upload-logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress ? (e) => onProgress(Math.round((e.loaded * 100) / e.total)) : undefined,
    });
    return response.data;
  },

  // Upload favicon to S3, returns { url }
  uploadFavicon: async (file, onProgress) => {
    const formData = new FormData();
    formData.append('favicon', file);
    const response = await api.post('/admin/site-settings/upload-favicon', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress ? (e) => onProgress(Math.round((e.loaded * 100) / e.total)) : undefined,
    });
    return response.data;
  },

  // Upload About page hero image to S3
  uploadAboutHero: async (file, onProgress) => {
    const formData = new FormData();
    formData.append('image', file);
    const response = await api.post('/admin/site-settings/upload-about-hero', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress ? (e) => onProgress(Math.round((e.loaded * 100) / e.total)) : undefined,
    });
    return response.data;
  },
};

